export default function isEmailValid(email: string): boolean {
  if (email.length === 0 || email.length > 254) {
    return false;
  }

  const parts = email.split("@");
  if (parts.length !== 2) {
    return false;
  }

  const [local, domain] = parts;
  const [localTrimmed, domainTrimmed] = [local.trim(), domain.trim()];
  if (local !== localTrimmed || domain !== domainTrimmed) {
    return false;
  }

  if (localTrimmed.length === 0 || localTrimmed.length > 63) {
    return false;
  }

  if (domainTrimmed === "") {
    return false;
  }

  if (domain.indexOf(".") === -1) {
    return false;
  }

  const domainSplit = domain.split(".");
  if (
    domainSplit.length < 2 ||
    domainSplit.some((part) => part.trim().length === 0)
  ) {
    return false;
  }

  try {
    const domainAsURL = `https://${domain}`;
    const domainAsURLParsed = new URL(domainAsURL);
    return domainAsURLParsed.hostname === domain;
  } catch {
    return false;
  }
}
